export default __webpack_public_path__ + "static/media/up-caret-icon.62763393.svg";